<template>
    <div class="substation_device_manage">
        <!-- 布局，组件 -->
        <!-- <me-collapes @collapesCb="collapesCb" :treeTitle="'设备树'" :style="`width:calc(${treeOuterWidth}px + 40px)`">
            <div
                class="leader-title"
                style="margin-top: 17px;margin-bottom: 20px;"
            >
                设备树
            </div>
            <div class="tree-container" :style="`width:calc(${treeOuterWidth}px + 40px)`">
                <me-tree
                    ref="subtree"
                    :treeData="treeList"
                    :treeLoading="treeLoading"
                    :treeToolBar="false"
                    :defaultProps="defaultProps"
                    :nodeKey="'device_ledger_id'"
                    :defaultExpandAll="false"
                    :defaultExpandedKeys="defaultExpandedKeys"
                    @handleTreeNodeClick="handleNodeClick"
                    @handleStretchClick="handleStretchClick"
                ></me-tree>
            </div>
        </me-collapes> -->
        <me-collapes @collapesCb="collapesCb" :treeTitle="'设备树'" :style="`width:calc(${treeOuterWidth}px + 40px)`">
            <div
                class="leader-title"
                style="margin-top: 17px;margin-bottom: 20px;"
            >
                设备树
            </div>
            <div class="tree-container" :style="`width:calc(${treeOuterWidth}px + 40px)`">
                <me-tree
                    ref="subtree"
                    :treeData="treeList"
                    :treeLoading="treeLoading"
                    :treeToolBar="false"
                    :defaultProps="defaultProps"
                    :nodeKey="'device_ledger_id'"
                    :defaultExpandAll="false"
                    :defaultExpandedKeys="defaultExpandedKeys"
                    @handleTreeNodeClick="handleNodeClick"
                    @handleStretchClick="handleStretchClick"
                ></me-tree>
            </div>
        </me-collapes>
        <div class="table-container" :style="`width:calc(100% - ${treeOuterWidth}px - 40px)`">
            <one_table
                :treeId="treeId"
                :treeLevel="treeLevel"
                :treeData="treeData"
                @reloadTree="reloadTree"
                v-if="!treeLevel || treeLevel == 'device_ledger_type_10'"
            ></one_table>
            <two_table
                :treeId="treeId"
                :treeLevel="treeLevel"
                :treeData="treeData"
                @reloadTree="reloadTree"
                v-else-if="treeLevel == 'device_ledger_type_20'"
            ></two_table>
            <three_table
                :treeId="treeId"
                :treeLevel="treeLevel"
                :treeData="treeData"
                @reloadTree="reloadTree"
                v-else-if="treeLevel == 'device_ledger_type_30'"
            ></three_table>
            <four_table
                :treeId="treeId"
                :treeLevel="treeLevel"
                :treeData="treeData"
                @reloadTree="reloadTree"
                v-else
            ></four_table>
        </div>
    </div>
</template>
<script>
import * as api from "./api/substation_device_manage";
import one_table from "./components/one_table.vue";
import two_table from "./components/two_table.vue";
import three_table from "./components/three_table.vue";
import four_table from "./components/four_table.vue";
import Tree from "@/comon/components/tree.vue";
import { getCodelistByKind } from "@/http/api.js";
import Collapes from "@/comon/components/collapse-block.vue";
export default {
    components: {
        one_table: one_table,
        two_table: two_table,
        three_table: three_table,
        four_table: four_table,
        "me-collapes": Collapes,
        "me-tree": Tree
    },
    data() {
        return {
            treeOuterWidth: 280,
            treeList: [],
            treeData: "",
            defaultProps: {
                children: "childList",
                label: "device_ledger_name"
            },
            treeId: "",
            treeLevel: "",
            defaultExpandedKeys: [], //默认展开的层数
            width: "calc(100% - 370px)",
        };
    },
    created() {
        this.getDeviceLedgerTree();
    },
    methods: {
        // 获取树图
        getDeviceLedgerTree() {
            api.getDeviceLedgerTree().then(res => {
                if (res) {
                    this.treeList = res.bus_json;
                    this.defaultExpandedKeys = [res.bus_json[0].device_ledger_id];
                    if (this.treeData) {
                        this.$nextTick(() => {
                            this.$refs.subtree.$refs.tree.setCurrentKey(
                                this.treeData.device_ledger_id
                            );
                            this.defaultExpandedKeys = [this.treeData.device_ledger_id];
                        });
                    } else {
                        this.handleNodeClick(this.treeList[0]);
                        this.$nextTick(() => {
                            this.$refs.subtree.$refs.tree.setCurrentKey(
                                this.treeData.device_ledger_id
                            );
                        });
                    }
                }
            });
        },
        reloadTree(node) {
            this.getDeviceLedgerTree();
        },
        // 树节点点击或更换时来自tree的传值
        handleNodeClick(val) {
            this.treeLevel = val.device_ledger_kind;
            this.$nextTick(() => {
                this.treeData = val;
                this.treeId = val.device_ledger_id;
            });
        },
        // 所有关闭dialog的清除验证的回调
        dialogClose(formName) {
            this.$nextTick(() => {
                this.$refs[formName].resetFields();
            });
        },
        handleStretchClick(treeOuterWidth) {
            this.treeOuterWidth = treeOuterWidth;
        },
        /**
         * 监听树结构收起展开
         */
        collapesCb(collapes) {
            this.width = collapes ? "calc(100% - 370px)" : "calc(100% - 61px)";
        }
    }
};
</script>
<style lang="scss">
.substation_device_manage {
    width: 100%;
    height: 100%;
    display: inline-flex;
    padding: 0px;
    box-sizing: border-box;
    padding: 0 2rem 0 0;
    .leader_style_menu_tree {
        background: none;
    }
    .filter-form {
        width: 90%;
        margin-left: 3%;
        .el-select {
            width: 100%;
        }
    }
    .tree-container {
      //  width: 280px;
        height: calc(100% - 40px);
      //  padding-right: 20px;
      //  margin-right: 20px;
        //  border-right: 1px solid rgb(179, 202, 222);
       // overflow-x: hidden;
        .el-scrollbar__wrap {
            overflow-x: hidden;
        }
        .leader-title {
            padding: 5px 0;
        }
        // .btn_container {
        //     padding: 0 0 5px 0;
        // }
        // .tree-wrap {
        //     .el-tree {
        //         background: transparent !important;
        //         color: #fff;
        //     }
        // }
        .el-tree {
            background: transparent !important;
            color: #fff;
        }
        .el-tree--highlight-current
            .el-tree-node.is-current
            > .el-tree-node__content {
            background-color: #1a6292;
        }
        .el-tree-node__content:hover {
            background-color: #1a6292;
        }
        .el-tree__empty-text {
            color: #fff;
        }
    }
    .title_container {
        width: 100%;
        text-indent: 20px;
        text-align: left;
        font-size: 16px;
        line-height: 40px;
        height: 40px;
        color: #484848;
        border-bottom: 1px solid #efefef;
    }
    .table-container {
        // width: calc(100% - 280px - 40px);
       // margin-right: 30px;
    }
    .el-scrollbar__wrap {
        overflow-x: hidden;
    }
    .filter-wrap {
        display: inline-flex;
        justify-content: space-between;
        align-items: center;
        width: 100%;
        margin-top: 10px;
        font-size: 14px;
        .el-input__inner {
            height: 30px;
            line-height: 30px;
        }
        .el-input__prefix,
        .el-input__suffix {
            display: flex;
            align-items: center;
        }
    }
}
</style>
